import PositionRange from "../core/positions"
import InternetObjectError  from "./io-error"

/**
 * Represents the validation error in InternetObject. This error is thrown when a validation
 * issue is found while validating the internet-object data against the associated schema.
 */
class IOValidationError extends InternetObjectError {
  /**
   * Creates a new `IOValidationError` error.
   *
   * @param errorCode {string} An error-code associated with this error
   * @param fact {string} The  reason for the error
   * @param pos {Position} The position object, for tracking line and columns. Optional
   * @param isEof {boolean} Indicates whether the error is caused by EOF. Optional
   * @param ssf {Function} The start statck function, removes the irrelavant frames from the stack trace
   * @internal
   */
  constructor(errorCode: string, fact?: string, posRange?: PositionRange, isEof: boolean = false, ssf?: any) {
    super(errorCode, fact, posRange, isEof, ssf)
    this.name = 'InternetObject(ValidationError)'
    this.updateMessage()
  }
}

export default IOValidationError
